import {
    ResultObj,
    allFetch,
} from "../Domain";
import { valueIsValid } from "../api";

/** 查詢工時規則主項 (參數)
 * @description 查詢工時規則主項 (參數)
 * @param {string} whrm_id 工時規則主項流水號
 * @param {string} whrm_name 工時規則主項名稱
 * @param {string} company_id 公司流水號
 * @param {string} general_manager_id 高階管理階層（前總經理室）流水號
 * @param {string} department_id 部門流水號
 * @param {string} position_id 據點流水號
 * @param {string} class_id 課級流水號
 * @param {string} group_id 組級流水號
 * @param {string} office_id 辦公室流水號
 * @param {string} visible 是否可見
 * @param {string} page 頁碼
 * @param {string} num_per_page 一頁幾筆
 */
export interface WorkHoursRuleMasterSearchParams {
    whrm_id: string;
    whrm_name: string;
    company_id: string;
    general_manager_id: string;
    department_id: string;
    position_id: string;
    class_id: string;
    group_id: string;
    office_id: string;
    visible: string;
    page: number;
    num_per_page: number;
}

/**@description 查詢工時規則主項 (回傳) */
export interface WorkHoursRuleMasterSearchResItem {
    calendar_name: string;
    class_id: string;
    cm_id: string;
    company_id: string;
    department_id: string;
    general_manager_id: string;
    group_id: string;
    note: string;
    office_id: string;
    position_id: string;
    visible: string;
    whrm_id: string;
    whrm_name: string;
}

/** @description 查詢工時規則主項 */
export const WorkHoursRuleMasterSearch = async (
    obj: WorkHoursRuleMasterSearchParams
): Promise<ResultObj<WorkHoursRuleMasterSearchResItem[]>> => {
    return await allFetch('WorkHoursRule/WorkHoursRuleMasterSearch', obj);
};


/** 新增工時規則主項 (參數)
 * @description 新增工時規則主項 (參數)
 * @param {string} whrm_name 工時規則主項名稱
 * @param {string} company_id 公司流水號
 * @param {string} general_manager_id 高階管理階層（前總經理室）流水號
 * @param {string} department_id 部門流水號
 * @param {string} position_id 據點流水號
 * @param {string} class_id 課級流水號
 * @param {string} group_id 組級流水號
 * @param {string} office_id 辦公室流水號
 * @param {string} note 備註
 * @param {string} cm_id 行事曆主項流水號
 */
export interface WorkHoursRuleMasterCreateParams {
    whrm_name: string;
    company_id: string;
    general_manager_id: string;
    department_id: string;
    position_id: string;
    class_id: string;
    group_id: string;
    office_id: string;
    note: string;
    cm_id: string;
}

/** @description 新增工時規則主項 */
export const WorkHoursRuleMasterCreate = async (
    obj: WorkHoursRuleMasterCreateParams
): Promise<ResultObj> => {
    return await allFetch('WorkHoursRule/WorkHoursRuleMasterCreate', obj);
};

/** 修改工時規則主項 (參數)
 * @description 修改工時規則主項 (參數)
 * @param {string} whrm_id 工時規則主項流水號
 * @param {string} whrm_name 工時規則主項名稱
 * @param {string} company_id 公司流水號
 * @param {string} general_manager_id 高階管理階層（前總經理室）流水號
 * @param {string} department_id 部門流水號
 * @param {string} position_id 據點流水號
 * @param {string} class_id 課級流水號
 * @param {string} group_id 組級流水號
 * @param {string} office_id 辦公室流水號
 * @param {string} note 備註
 * @param {string} cm_id 行事曆主項流水號
 * @param {string} visible 是否可見
 */
export interface WorkHoursRuleMasterUpdateParams {
    whrm_id: string;
    whrm_name: string;
    company_id: string;
    general_manager_id: string;
    department_id: string;
    position_id: string;
    class_id: string;
    group_id: string;
    office_id: string;
    note: string;
    cm_id: string;
    visible: string;
}

/** @description 修改工時規則主項 */
export const WorkHoursRuleMasterUpdate = async (
    obj: WorkHoursRuleMasterUpdateParams
): Promise<ResultObj> => {
    return await allFetch('WorkHoursRule/WorkHoursRuleMasterUpdate', obj);
};


/** 查詢工時規則細項(個人) (參數)
 * @description 查詢工時規則細項(個人) (參數)
 * @param {string} whrm_id 工時規則主項流水號
 * @param {string} whrdp_id 工時規則細項流水號
 * @param {string} visible 是否可見
 * @param {string} page 頁碼
 * @param {string} num_per_page 一頁幾筆
 */
export interface WorkHoursRuleDetailPersonSearchParams {
    whrm_id: string;
    whrdp_id: string,
    visible: string,
    page: number,
    num_per_page: number
}

/** @description 查詢工時規則細項(個人) (回傳)*/
export interface WorkHoursRuleDetailPersonSearchResItem {
    check_type: string;
    cre_time: string;
    every_few_days: number;
    note: string;
    overtime_work_hours_max: number;
    vacation_min: number;
    visible: string;
    whrdp_id: number;
    whrdp_name: string;
    whrm_id: string;
    work_hours_max: number;
}

/** @description 查詢工時規則細項(個人) */
export const WorkHoursRuleDetailPersonSearch = async (
    obj: WorkHoursRuleDetailPersonSearchParams
): Promise<ResultObj<WorkHoursRuleDetailPersonSearchResItem[]>> => {
    return await allFetch('WorkHoursRule/WorkHoursRuleDetailPersonSearch', obj);
};


/** 新增工時規則細項(個人) (參數)
 * @description 新增工時規則細項(個人) (參數)
 * @param {string} whrm_id 工時規則主項流水號
 * @param {string} whrdg_name 規則細項名稱
 * @param {string} every_few_days 每幾天
 * @param {string} work_hours_max 最多工時時數
 * @param {string} overtime_work_hours_max 最多加班時數
 * @param {string} vacation_min 最少假日日數
 * @param {string} note 備註
 * @param {string} check_type 檢查種類
*/
export interface WorkHoursRuleDetailPersonCreateParams {
    whrm_id: string,
    whrdp_name: string,
    every_few_days: string,
    work_hours_max: string,
    overtime_work_hours_max: string,
    vacation_min: string,
    note: string,
    check_type: string
}

/** @description 新增工時規則細項(個人) */
export const WorkHoursRuleDetailPersonCreate = async (
    obj: WorkHoursRuleDetailPersonCreateParams
): Promise<ResultObj> => {
    return await allFetch('WorkHoursRule/WorkHoursRuleDetailPersonCreate', obj);
};


/** 修改工時規則細項(個人) (參數)
 * @description 修改工時規則細項(個人) (參數)
 * @param {string} whrdp_id 工時規則細項流水號
 * @param {string} whrm_id 工時規則主項流水號
 * @param {string} whrdg_name 規則細項名稱
 * @param {string} every_few_days 每幾天
 * @param {string} work_hours_max 最多工時時數
 * @param {string} overtime_work_hours_max 最多加班時數
 * @param {string} vacation_min 最少假日日數
 * @param {string} note 備註
 * @param {string} check_type 檢查種類
 * @param {string} visible 是否可見
*/
export interface WorkHoursRuleDetailPersonUpdateParams {
    whrdp_id: string,
    whrm_id: string,
    whrdp_name: string,
    every_few_days: string,
    work_hours_max: string,
    overtime_work_hours_max: string,
    vacation_min: string,
    note: string,
    check_type: string,
    visible: string,
}

/** @description 修改工時規則細項(個人) */
export const WorkHoursRuleDetailPersonUpdate = async (
    obj: WorkHoursRuleDetailPersonUpdateParams
): Promise<ResultObj> => {
    return await allFetch('WorkHoursRule/WorkHoursRuleDetailPersonUpdate', obj);
};

/** 查詢工時規則細項(部門) (參數)
 * @description 查詢工時規則細項(部門) (參數)
 * @param {string} whrm_id 工時規則主項流水號
 * @param {string} whrdg_id 工時規則細項流水號
 * @param {string} visible 是否可見
 * @param {string} page 頁碼
 * @param {string} num_per_page 一頁幾筆
 */
export interface WorkHoursRuleDetailGroupSearchParams {
    whrm_id: string;
    whrdg_id: string,
    visible: string,
    page: number,
    num_per_page: number
}

/** @description 查詢工時規則細項(部門) (回傳)*/
export interface WorkHoursRuleDetailGroupSearchResItem {
    check_type: string;
    cre_time: string;
    every_few_days: number;
    note: string;
    sc_id_min_json: string;
    ud_id_except_list: string;
    ud_id_list: string;
    visible: string;
    whrdg_id: number;
    whrdg_name: string;
    whrm_id: string;
}

/** @description 查詢工時規則細項(部門) */
export const WorkHoursRuleDetailGroupSearch = async (
    obj: WorkHoursRuleDetailGroupSearchParams
): Promise<ResultObj<WorkHoursRuleDetailGroupSearchResItem[]>> => {
    return await allFetch('WorkHoursRule/WorkHoursRuleDetailGroupSearch', obj);
};

/** 新增工時規則細項(部門) (參數)
 * @description 新增工時規則細項(部門) (參數)
 * @param {string} whrm_id 工時規則主項流水號
 * @param {string} whrdg_name 規則細項名稱
 * @param {string} every_few_days 每幾天
 * @param {string} ud_id_list 某些職責們
 * @param {string} sc_id_min_json 最少要幾個某班表
 * @param {string} ud_id_except_list 某些職責們不計
 * @param {string} note 備註
 * @param {string} check_type 檢查種類
 * */
export interface WorkHoursRuleDetailGroupCreateParams {
    whrm_id: string,
    whrdg_name: string,
    every_few_days: string,
    ud_id_list: string[],
    sc_id_min_json: { key: string, value: string }[],
    ud_id_except_list: string[],
    note: string,
    check_type: string
}

/** @description 新增工時規則細項(部門) */
export const WorkHoursRuleDetailGroupCreate = async (
    obj: WorkHoursRuleDetailGroupCreateParams
): Promise<ResultObj> => {
    return await allFetch('WorkHoursRule/WorkHoursRuleDetailGroupCreate', obj);
};

/** 修改工時規則細項(部門) (參數)
 * @description 修改工時規則細項(部門) (參數)
 * @param {string} whrdg_id 工時規則細項流水號
 * @param {string} whrm_id 工時規則主項流水號
 * @param {string} whrdg_name 規則細項名稱
 * @param {string} every_few_days 每幾天
 * @param {string} ud_id_list 某些職責們
 * @param {string} sc_id_min_json 最少要幾個某班表
 * @param {string} ud_id_except_list 某些職責們不計
 * @param {string} note 備註
 * @param {string} check_type 檢查種類
 * @param {string} visible 是否可見
 * */
export interface WorkHoursRuleDetailGroupUpdateParams {
    whrdg_id: string,
    whrm_id: string,
    whrdg_name: string,
    every_few_days: string,
    ud_id_list: string[],
    sc_id_min_json: { key: string, value: string }[],
    ud_id_except_list: string[],
    note: string,
    check_type: string,
    visible: string
}

/** @description 修改工時規則細項(部門) */
export const WorkHoursRuleDetailGroupUpdate = async (
    obj: WorkHoursRuleDetailGroupUpdateParams
): Promise<ResultObj> => {
    return await allFetch('WorkHoursRule/WorkHoursRuleDetailGroupUpdate', obj);
};